import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import './index.css';
import i18n from './i18n';
import AppContainer from './AppContainer';
import reducers from './reducers';

const store = process.env.REACT_APP_CHROME_EXTENSION && process.env.REACT_APP_CHROME_EXTENSION === 'true' ? createStore(
  reducers /* preloadedState, */,
  compose(
    applyMiddleware(thunkMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  ),
) : createStore(
  reducers /* preloadedState, */,
  compose(applyMiddleware(thunkMiddleware)),
);

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </I18nextProvider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js